
export const archiveFilter = () => {
    const filterForm = document.getElementById('category-filter-form');
    const select = document.getElementById('category-select');

    if (filterForm && select) {
		const submitButton = filterForm.querySelector('button[type="submit"]');
		const toggleButtonState = () => {
			if (submitButton) {
				submitButton.disabled = !select.value;
			}
		};
		toggleButtonState();
		select.addEventListener('change', toggleButtonState);
        filterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const selectedUrl = select.value;
            if (selectedUrl) {
                window.location.href = selectedUrl;
            }
        });
    }
}